import {
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import {
  listTableColumns,
  libraryTableColumns,
  tagTableColumns,
  promptTableColumns,
  goalTableColumns,
  authorTableColumns,
  seriesTableColumns,
  publisherTableColumns,
  characterTableColumns,
} from "./table";
import { LetterbooksSerializersLetterbooks } from "types/serializers";

export type LetterbookTableColumnLookupType = ({
  context,
  overrides,
}: {
  context: LetterbooksSerializersLetterbooks;
  overrides: string[] | null;
}) => LetterlistTableColumnSettingType[];

const generator = {
  list: listTableColumns,
  library: libraryTableColumns,
  tag: tagTableColumns,
  prompt: promptTableColumns,
  goal: goalTableColumns,
  author: authorTableColumns,
  series: seriesTableColumns,
  publisher: publisherTableColumns,
  character: characterTableColumns,
};

// Convert the query params to a sort object
function generateColumnsOverride(context: LetterbooksSerializersLetterbooks): string[] {
  const { searchParams } = context;

  if (searchParams.columns?.length > 0) {
    return searchParams.columns.split(",");
  }

  return [];
}

interface FindTableColumnsReturnType {
  tableColumns: LetterlistTableColumnSettingType[];
  unusedColumns: LetterlistTableColumnSettingType[];
}
// Finds the current sort order option from the existing ones
export default function findTableColumns(
  context: LetterbooksSerializersLetterbooks
): FindTableColumnsReturnType {
  const overrides = generateColumnsOverride(context);
  const lookup = generator[context.type];
  return lookup({ context, overrides }) as FindTableColumnsReturnType;
}
